module.exports = __webpack_public_path__ + "static/design-3-f8393968472edf577fa8c1e6f9575a7d.png";